<template>
    <div class="right-part mail-list bg-white">
        <div class="p-15 b-b">
            <div class="d-flex align-items-center">
                <div>
                    <h4>Drafts</h4>
                    <span>Here is the list of draft mail(s)</span>
                </div>
            </div>
        </div>
        <div class="bg-light p-15 d-flex align-items-center do-block">
            <div class="btn-group m-t-5 m-b-5">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input sl-all" id="cstall" :disabled="drafts.length === 0" @click="selectAll" v-model="allChecked">
                    <label class="form-check-label" for="cstall">Check All</label>
                </div>
            </div>
            <div class="ml-auto">
                <div class="btn-group m-r-10" role="group" aria-label="Button group with nested dropdown">
                    <button type="button" class="btn btn-outline-secondary font-18" @click="getDraftMails(1)"><i class="mdi mdi-reload"></i></button>
                    <button type="button" class="btn btn-outline-secondary font-18" @click="deleteMail"><i class="mdi mdi-delete"></i></button>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table email-table no-wrap table-hover v-middle">
                <tbody>
                <tr v-for="(m, index) in drafts" v-bind:key="index">
                    <!-- label -->
                    <td class="chb">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" :id="'mail'+m.id" v-model="mailids" :value="m.id" @click="select(m.id)">
                            <label class="form-check-label" :for="'mail'+m.id">&nbsp;</label>
                        </div>
                    </td>
                    <!-- User -->
                    <!--<td class="user-image"><img src="../../../assets/images/users/1.jpg" alt="user" class="rounded-circle" width="30"></td>-->
                    <!--<td class="user-name">-->
                    <!--<h6 class="m-b-0"><span v-for="(r, index) in m.receivers" v-bind:key="index">{{r.receiver_fname}} {{r.receiver_lname}} &nbsp; &nbsp;</span></h6>-->
                    <!--</td>-->
                    <!-- Message -->
                    <td class="max-texts" @click="showMail(m.id)">
                        <a class="link" href="javascript: void(0)">
                            <span class="blue-grey-text text-darken-4" v-if="!isNullOrEmpty(m.subject)">{{m.subject}}</span>
                            <span class="blue-grey-text text-darken-4" v-if="isNullOrEmpty(m.subject)">( no subject )</span>
                        </a>
                    </td>
                    <!-- Attachment -->
                    <td class="clip" @click="showMail(m.id)"><i class="fa fa-paperclip" v-if="m.attachments.length > 0"></i></td>
                    <!-- Time -->
                    <td class="date-time" @click="showMail(m.id)">{{m.created_at | short}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="p-15 m-t-30">
            <nav aria-label="Page navigation example">
                <paginate
                        :page-count=pageCount
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="pageHandler"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :next-class="'page-link'"
                        :container-class="'pagination float-right'"
                        :page-class="'page-link'">
                </paginate>
            </nav>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import moment from 'moment';

    export default {
        name: "Draft",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                mailid: '',
                drafts: [],
                pageCount: 1,
                total: 0,
                allChecked: false,
                mailids: []

            };
        },
        mounted() {
            this.getDraftMails(1);
        },
        methods: {
            selectAll() {
                if(this.mailids.length === this.drafts.length) {
                    this.mailids = [];
                } else {
                    this.mailids = [];
                    this.mailids = this.drafts.map(mail => mail.id);
                }
                this.isAllchecked();
            },
            isAllchecked() {
                this.allChecked = (this.mailids.length > 0) && (this.mailids.length === this.drafts.length);
                console.log(this.allChecked);
            },
            select(id) {
                if(this.mailids.includes(id)) {
                    this.mailids.splice(this.mailids.indexOf(id), 1);
                } else {
                    this.mailids.push(id);
                }
                this.isAllchecked();
            },
            showMail(mailid) {
                this.$router.push({name: "compose", params: {mailid: mailid}});
            },
            getDraftMails(page) {
                this.$http
                .get("/mailbox/drafts", {
                    params: {
                        page: page,
                        perPage: 10
                    }
                })
                .then(reply => {
                    this.total      = reply.data.total;
                    this.drafts = reply.data.mails;
                    this.setPageCount();
                })
                .catch(err => {
                    console.error(err);
                })
            },
            pageHandler(pageNum) {
                this.getDraftMails(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            isNullOrEmpty(str) {
                if(str !== null && str !== undefined && (str).trim() !== '') {
                    return false;
                } else {
                    return true;
                }
            },
            async deleteMail() {
                if(this.mailids.length > 0) {
                    await this.$http.delete("/mailbox", {data: {mailids: this.mailids}});
                    await this.getDraftMails(1);
                    this.mailids = [];
                    await this.isAllchecked();
                } else {
                    this.$toastr('error', 'Please select a mail to delete.', 'Delete Fail');
                }
            }
        }
    }
</script>

<style scoped>

</style>
